import { Form, Formik } from 'formik';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { DefaultLink } from '@hivebrite/design-system/Link';
import { toast } from '@hivebrite/design-system/Toast';

import {
  setAuthAttempt,
  clearAuthAttempt,
  METHODS,
} from 'hb-react/publicoffice/apps/LoginApp//utils/authAttemptSessionStorage';
import { postUserSession } from 'hb-react/publicoffice/apps/LoginApp/requests';
import getRuntimeDefaultTimeZone from 'hb-react/shared/components/EventDate/utils/getRuntimeDefaultTimeZone';
import {
  Email,
  Hidden,
  Password,
} from 'hb-react/shared/components/formik/components/inputs';
import { useQueryParams } from 'hb-react/shared/hooks/useQueryParams';

const LoginEmail = ({ currentNetwork, settings, setDisplayMFA }) => {
  const query = useQueryParams();

  const validate = { required: true, minLength: 10 };
  const initialValues = {
    network_id: currentNetwork?.identifier,
    redirect_to: query?.redirect_to,
    user: {
      email: '',
      network_id: currentNetwork?.id,
      password: '',
      remember_me: 1,
      timezone: getRuntimeDefaultTimeZone(),
    },
  };
  const {
    accessibility_email_label: accessibilityEmailLabel,
    accessibility_password_label: accessibilityPasswordLabel,
    button_text: buttonText,
    email_placeholder: emailPlaceholder,
    enabled,
    password_placeholder: passwordPlaceholder,
    password_reset_text: passwordResetText,
    password_reset_url: passwordResetUrl,
  } = settings;

  const handleSubmit = async (values) => {
    setAuthAttempt(METHODS.EMAIL);

    try {
      await postUserSession(values);
    } catch (e) {
      clearAuthAttempt();

      if (e?.response?.data?.error === 'OTP_REQUIRED') {
        setDisplayMFA(values);
      } else {
        toast.error(e?.response?.data?.error || __('An error has occurred'));
      }
    }
  };

  return enabled ? (
    <Box mt={3}>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {(formik) => (
          <StyledForm>
            <Hidden name="network_id" />
            <Hidden name="user[network_id]" />
            <Hidden name="user[timezone]" />
            <Hidden name="redirect_to" />
            <Email
              name="user[email]"
              label={I18n.t('web.networks.show.session.email')}
              placeholder={emailPlaceholder}
              validate={validate}
              aria-label={accessibilityEmailLabel}
            />
            <Password
              name="user[password]"
              autoComplete="off"
              label={I18n.t('web.networks.show.session.password')}
              placeholder={passwordPlaceholder}
              validate={validate}
              aria-label={accessibilityPasswordLabel}
              mb={5}
            />
            <Box
              mt={-1}
              mb={3}
              flexDirection="column"
              display="inline-flex"
              style={{ float: 'right' }}
            >
              <DefaultLink href={passwordResetUrl}>
                {passwordResetText}
              </DefaultLink>
            </Box>
            <Hidden name="user[remember_me]" />
            <CustomButton type="submit" disabled={!formik.isValid}>
              {buttonText}
            </CustomButton>
          </StyledForm>
        )}
      </Formik>
    </Box>
  ) : null;
};

export default LoginEmail;

const StyledForm = styled(Form)`
  width: 100%;
`;

const CustomButton = styled(Button)`
  height: 36px;
  margin-top: 12px;
  width: 100%;
`;
